import * as types from "../actions/actionTypes";
import log from "../utils/log";

export const showPdfFile = (file, positionX, positionY, orientation) => {
  log.info("[PDF ACTION] SHOW_PDF_FILE");
  return {
    type: types.SHOW_PDF_FILE,
    file,
    positionX,
    positionY,
    orientation
  };
};

export const hidePdfFile = () => {
  log.info("[PDF ACTION] HIDE_PDF_FILE");
  return {
    type: types.HIDE_PDF_FILE
  };
};
export const setCanvasReadyPdfFile = () => {
  log.info("[PDF ACTION] SET_CANVAS_READY_PDF_FILE");
  return {
    type: types.SET_CANVAS_READY_PDF_FILE
  };
};




// WEBPACK FOOTER //
// ./src/actions/pdfActions.js